export default "https://cdn-static.gokick.com/assets/ec4df3605d889435bba193590f9e5f4fca0b05f8/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";